module.exports = __webpack_public_path__ + "images/green-laurel-bcd91e5833ff046e407f7c878f8ec7c8.png";